import { LocationRequest } from "../../../../physician/models/location-request.model";

export class PractitionerLocations {
  userid: number;
  uAction: string;
  healthsystemid: number;
  addressId: number;
  healthSystemIds: number[];
  primaryPhoneNumber: string;
  faxNumber: string;
  addressRequest: LocationRequest;
  practitionerWorkingHoursDto: any;
}
